/** Гарантии монтажника */
export default {
  name: 'InstallerGuaranties',
  props: {
    /** Тип отображаемых гарантий (approve, history) */
    type: String,
  },
  data() {
    return {
      /** Список гарантий */
      certificates: [],
      /** Процесс загрузки данных */
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    /** Загрузить список гарантий */
    loadCertificates(status) {
      this.loading = true;
      this.$store.getters.axl
        .post('guaranties/api/guaranties/list', {
          profile_id: this.user.profile_id,
          status,
        })
        .then((response) => {
          this.certificates = response.data.guaranties;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    approveGuarantee(guarantee, approve) {
      this.$store.getters.axl
        .post('guaranties/api/guaranties/set-status', {
          profile_id: this.user.profile_id,
          guarantee_id: guarantee.id,
          confirmed: approve ? 1 : 0,
        })
        .then(() => {
          this.certificates = this.certificates.filter(el => el.id !== guarantee.id);
          this.$store.dispatch('ShowInfo', `Гарантия ${approve ? 'подтверждена' : 'Отклонена'}`);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    const status = this.type === 'approve' ? 'new' : 'confirmed';
    this.loadCertificates(status);
  },
};
